export const LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES = 'submit_privacy_policies';
export const LOCAL_STORAGE_PRIVACY_POLICIES = 'privacy_policies';
export const LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY = 'allowed_privacy_policy';
export const LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES =
  'unlogged_user_privacy_policies';
